import React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '@material-ui/core/ButtonBase';
import { makeStyles } from '@material-ui/core/styles';
import ReactTooltip from 'react-tooltip';
import ClassNames from 'classnames';

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: props => props.ml,
    height: 39,
    width: 39,
    border: '1px solid #E3E3E3',
    borderRadius: 5,
    '& img': {
      height: 20,
    },
  },
  big: {
    width: 90,
    [theme.breakpoints.down('md')]: {
      width: 70,
    },
  },
  isActiveLike: {
    borderColor: '#01619B',
  },
  isActiveDisLike: {
    borderColor: '#E14B4B',
  },
}));

const ActionButton = ({
  icon,
  ml,
  id,
  label,
  clickHandler,
  isBig,
  isActive,
}) => {
  const classes = useStyles({ ml });
  return (
    <>
      <ReactTooltip id={id} place="top" type="light" border>
        {label}
      </ReactTooltip>
      <ButtonBase
        className={ClassNames(classes.root, {
          [classes.big]: isBig,
          [classes.isActiveLike]: isActive && id === 'like',
          [classes.isActiveDisLike]: isActive && id === 'dislike',
        })}
        data-tip=""
        data-for={id}
        onClick={clickHandler}
      >
        <img src={icon} alt="" />
      </ButtonBase>
    </>
  );
};

ActionButton.propTypes = {
  icon: PropTypes.string,
  ml: PropTypes.number,
  id: PropTypes.string,
  label: PropTypes.string,
  clickHandler: PropTypes.func,
  isBig: PropTypes.bool,
  isActive: PropTypes.bool,
};

ActionButton.defaultProps = {
  ml: 0,
};

export default ActionButton;
